import React, { useState } from 'react'; 
import { useDispatch, useSelector } from 'react-redux';
import CustManCards from './CustManCards';
import './CloseScheme.css';
import { useNavigate } from 'react-router-dom';
import CloseMemSch from './CloseMemSch';
import { setReduxSchemeID } from '../../Redux/store/authSlice';
import warningIcon from '../common/asset1/warning-symbol.svg';
const CloseScheme = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    customerId: '',
    schemeId: '',
    schemeName: '',
  });
  const [showCloseMemSch, setShowCloseMemSch] = useState(false); 
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const additionalCustomerId = useSelector((state) => state.auth.additionalCustomerId);
  const [errors, setErrors] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const viewdetailhandleClick = () => {
    navigate('/home/view-detail-scheme');
  };

  const onClickGoBack = () => {
    navigate('/admin/home/viewing-user-profile');
  };

  
  const handleProceedClick = async (e) => {
    e.preventDefault();
    dispatch(setReduxSchemeID(formData.schemeId));
    const newErrors = {};
    if (!formData.customerId.trim()) {
      newErrors.customerId = 'Customer ID is required.';
    }
    if (!formData.schemeId.trim()) {
      newErrors.schemeId = 'Scheme ID is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const requestBody = {
      customerEnrolledSchemeId: 0, 
      fullName: formData.fullName,
      customerId: formData.customerId,
      schemeId: formData.schemeId,
      schemeName: formData.schemeName,
    };

  {/* try {
      const response = await fetch('https://localhost:7040/api/enrolledscheme/closeuserscheme', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        console.log('Scheme closed successfully.');
        setShowCloseMemSch(true);
      } else {
        console.error('Failed to close the scheme:', response.status);
      }
    } catch (error) {
      console.error('An error occurred while closing the scheme:', error);
    }  */}
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' })); 
    };
    const mockResponse = async () => {
      return new Promise((resolve) =>
        setTimeout(() => {
          resolve({ ok: true, status: 200 }); 
        }, 1000) 
      );
    };
  
    try {
      const response = await mockResponse();
  
      if (response.ok) {
        console.log("Scheme closed successfully.");
        setShowCloseMemSch(true); 
      } else {
        console.error("Failed to close the scheme:", response.status);
      }
    } catch (error) {
      console.error("An error occurred while closing the scheme:", error);
    }
  };
  

  return (
    <>
      {showCloseMemSch ? (
        <CloseMemSch /> 
      ) : (
        <div className="whole-mysave-cont">
          <CustManCards />
          <div className="close-use-out">
            <div className="close-use-cont">Close a User's Scheme</div>
            <form>
              <div className="close-form">
                <label>
                  Full Name
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Enter User Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                  />
                  
                </label>

                <label>
                  Customer ID
                  <input
                    type="text"
                    name="customerId"
                    placeholder="Enter your ID"
                    value={formData.customerId}
                    onChange={handleInputChange}
                  
                  />
                     {errors.customerId && (
                    <div className="error-reg-icon-out">
                       <img
        src={warningIcon}
        alt="Warning-Icon"
        className="warning-icon"
      />
                      <span className="error-register-now">{errors.customerId}</span>
                    </div>
                  )}
                </label>
              </div>

              <div className="close-form">
                <label>
                  Scheme Name
                  <input
                    type="text"
                    name="schemeName"
                    placeholder="Enter Scheme Name"
                    value={formData.schemeName}
                    onChange={handleInputChange}
                  />
                </label>

                <label>
                  Customer's Scheme ID
                  <input
                    type="text"
                    name="schemeId"
                    placeholder="Enter Customer's Scheme ID"
                    value={formData.schemeId}
                    onChange={handleInputChange}
                  />
                    {errors.schemeId && (
                    <div className="error-reg-icon-out">
                       <img
        src={warningIcon}
        alt="Warning-Icon"
        className="warning-icon"
      />
                      <span className="error-register-now">{errors.schemeId}</span>
                    </div>
                  )}
                </label>
              </div>

              <button className="close-proceed" onClick={handleProceedClick}>
                Proceed
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default CloseScheme;
